import dayjs from 'dayjs'

export const mapResponseToJob = (jobs, $date) => {
  return jobs.map(j => {
    const userEmail = localStorage.getItem('userEmail')
    return {
      jobAdId: j._id.$oid,
      bookingId: j.Booking && j.Booking[0].bookingId,
      companyId: j.Company && j.Company[0]._id.$oid,
      companyLogo: j.Company && j.Company[0].companyLogo,
      companyName: j.Company && j.Company[0].compName,
      jobAdThumbnail: j.thumbNailLink,
      industry: j.businessType.join(', '),
      title: j.jobTitle,
      presentYourCompany:
        j.presentYourCompany && j.presentYourCompany.length > 300
          ? j.presentYourCompany.substr(0, 300) + '...'
          : j.presentYourCompany,
      tasks: j.taskDescription,
      benefits: j.employeeBenefits,
      field: j.fieldOfActivity.join(', '),
      employmentType: j.employmentType,
      created: j.publishDate ? dayjs.utc(j.publishDate.$date).fromNow() : '',
      location: j.jobLocation,
      jobVideo: j.jobReelLink,
      hasJobCode:
        !!(j.JobCode && j.JobCode[0]) ||
        (j.Booking && j.Booking[0] && j.Booking[0].isConnectedProduct),
      jobCode: j.JobCode,
      isApplied: j.isApplied,
      // applied: j.appliedCandidateEmail && j.appliedCandidateEmail.includes(userEmail),
      // marked: j.markedCandidateEmail && j.markedCandidateEmail.includes(userEmail)
    }
  })
}
